import { useQuery } from 'react-query';

import Api from '../../api/api';

export const getReportedPostByPostId = async (reportedPostId: string) => {
  const [response, bodyOrError] = await Api.get(`posts/${reportedPostId}/reported`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetReportedPostByPostId = (reportedPostId: string) =>
  useQuery(['getReportedPostByPostId', reportedPostId], () => getReportedPostByPostId(reportedPostId), {
    enabled: reportedPostId !== 'new' || !!reportedPostId,
  });
